"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tickets_1 = require("./tickets");
exports.default = {
    TicketsSDK: tickets_1.TicketsSDK,
};
//# sourceMappingURL=index.js.map